export default {
  id: "page10",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",
  show: "parseInt(values.respondent_dzieci)>0",
  questions: [
    {
      type: "justlabel",
      number: "21a",
      label:
        "Czy Pana(i) dziecko jada i jeżeli tak, to jak często następujące rodzaje <span class='has-text-danger'>gotowych produktów z lodówki</span>?",
      info:
        "Dla każdego deseru (w wierszu) proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością."
    },
    {
      type: "choice_names",
      options: [
        "Raz w tygodniu lub częściej",
        "1-2 razy w miesiącu",
        "Raz na 2-3 miesiące",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label: 'Deser "dziecięcy" typu Monte, Paula, Mikuś',
      type: "radio",
      id: "kategoria5_dzieciMonte",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: 'Serki "dziecięce" typu Danonki, Bakuś',
      type: "radio",
      id: "kategoria5_dzieciDanonki",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page10.js